export default __webpack_public_path__ + "static/banner-4-9ab3ba4e65ab449c3b07d4bfb92023b9.png";